import { getCompanyAppointmentUrlSegment } from '../../shared/booking/appointments/companyAppointmentRouting';

/**
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {Record<string, unknown>} item normalized appointment or meeting row
 */
export function openCalendarItem(navigate, item) {
  if (item?.type === 'meeting') {
    const seg = item.shortSlug ?? item.id;
    navigate(`/app/overview/meeting/${seg}`, { state: { meeting: item } });
    return;
  }
  const appointmentSegment = getCompanyAppointmentUrlSegment(item) || item.id;
  navigate(`/app/overview/appointment/${appointmentSegment}`, {
    state: { appointment: item },
  });
}
